import React from 'react';
import './LegalPolicies.css'; // Create this CSS file
import useScrollToTop from './useScrollToTop';

const PrivacyPolicy = () => {
  useScrollToTop();
  return (
    <div className="policy-page">
      <h1>Privacy Policy</h1>
      <p>
        At Housekaar Construction Company, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information. We are currently operating with a focus on minimizing data collection.
      </p>

      <section>
        <h2>Data We Currently Collect</h2>
        <p>
          As of now, Housekaar Construction Company primarily collects data that is essential for the basic operation of our website and to facilitate communication with potential clients. This includes:
        </p>
        <ul>
          <li>
            <strong>Information You Provide Directly:</strong> When you contact us through our website (e.g., via a contact form or email), we may collect the information you provide, such as your name, contact details (email, phone number), and any other information you choose to include in your inquiry.
          </li>
          <li>
            <strong>Technical Data:</strong> Our web server may automatically log certain technical information related to your visit, such as your IP address, browser type, and operating system. This data is generally used for website administration and security purposes.  We do not routinely analyze this data in a way that identifies individual users.
          </li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Data (Currently)</h2>
        <p>
          The data we currently collect is used in the following ways:
        </p>
        <ul>
          <li>
            <strong>Communication:</strong> To respond to your inquiries, provide you with information about our services, and communicate with you as necessary regarding your requests.
          </li>
          <li>
            <strong>Website Operation and Security:</strong>  The technical data we collect helps us to ensure our website functions correctly, remains secure, and is protected against misuse.
          </li>
        </ul>
      </section>

      <section>
        <h2>Data Sharing</h2>
        <p>
          Housekaar Construction Company is committed to protecting your data.  Currently, we limit data sharing.  We may share your information in the following limited circumstances:
        </p>
        <ul>
          <li>
            <strong>Service Providers:</strong> We may share your information with trusted service providers who assist us in operating our website, conducting our business, or serving you (e.g., website hosting providers). We will ensure that these providers are bound by appropriate confidentiality and data protection agreements.
          </li>
          <li>
            <strong>Legal Obligations:</strong> We may disclose your information if required to do so by law or in response to valid legal requests, such as a court order or government investigation.
          </li>
        </ul>
      </section>

      <section>
        <h2>Data Security</h2>
        <p>
          We implement reasonable security measures to protect your data from unauthorized access, alteration, or disclosure. These measures include [Describe your security measures, e.g., secure server hosting, encryption of data in transit, access controls]. We regularly review and update our security practices to address evolving threats.
        </p>
      </section>

      <section>
        <h2>Your Rights (Future Considerations)</h2>
        <p>
          While our current data collection is limited, we acknowledge that you may have certain rights regarding your personal information under applicable data protection laws.  In the event that our data collection practices expand in the future, these rights may include:
        </p>
        <ul>
          <li>
            <strong>Access:</strong> The right to request access to the personal data we hold about you.
          </li>
          <li>
            <strong>Correction:</strong> The right to request that we correct any inaccuracies in your personal data.
          </li>
          <li>
            <strong>Deletion:</strong> The right to request that we delete your personal data, subject to certain legal limitations.
          </li>
          <li>
            <strong>Objection:</strong> The right to object to the processing of your personal data in certain circumstances.
          </li>
          <li>
            <strong>Data Portability:</strong> The right to receive your personal data in a structured, commonly used, and machine-readable format.
          </li>
        </ul>
        <p>
          We will provide information on how to exercise these rights if and when our data collection practices change.
        </p>
      </section>

      <section>
        <h2>Cookie Policy</h2>
        <p>
          Please refer to our <a href="/cookie-policy">Cookie Policy</a> for detailed information about how we use cookies on our website.
        </p>
      </section>

      <section>
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our data practices or legal requirements. We will post any revised Privacy Policy on this page. We encourage you to review this policy periodically for updates.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or our data practices, please contact us at:help@housekaar.com
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;